import ApiClient from './ApiClient';
/* global axios */

// Contador "Por Facturar" (Victor 2026-06-09): pagos detectados HOY · solo 3 cuentas.
class PorFacturarAPI extends ApiClient {
  constructor() {
    super('por_facturar', { accountScoped: true });
  }

  // Filtros (Victor 2026-06-12): from/to (YYYY-MM-DD) para el filtro Rango.
  stats(from = null, to = null) {
    const params = from && to ? { from, to } : {};
    return axios.get(`${this.url}/stats`, { params });
  }

  // Marca el lead como facturado (lo saca de la lista de pendientes).
  markBilled(dealId) {
    return axios.post(`${this.url}/${dealId}/mark_billed`);
  }
}

export default new PorFacturarAPI();
